import processsearchresults from '../../_utilities/processsearchresults';
import recursiveLanguageResolve from '../../_utilities/recursive-language-resolve';

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state.items = action.value.items;
        state.totalItemCount = action.value.totalItemCount;
        break;
      default:
        break;
    }
    return state;
  };

  window.swinger
    .app({
      type: 'library-slider',
      component: 'library-slider',
      reducer: reducer(),
    })
    .then((app) => {
      console.log('Library slider initialized');
      const { language } = window.swinger.config;
      const state = app.store.getState();

      let componentName = 'card-movie';
      let keyName = 'movies';
      let apiUrl = `${window.swinger.config.apiRoutes.searchMovies}`;
      let dataSet = 'library';
      switch (state.kind) {
        default:
        case 'movies':
          componentName = 'card-movie';
          keyName = 'movies';
          apiUrl = `${window.swinger.config.apiRoutes.searchMovies}`;
          break;
        case 'scenes':
          componentName = 'card-scene';
          keyName = 'scenes';
          apiUrl = `${window.swinger.config.apiRoutes.searchScenes}`;
          break;
        case 'categories':
          componentName = 'card-category';
          keyName = 'categories';
          apiUrl = `${window.swinger.config.apiRoutes.searchCategories}`;
          dataSet = 'likes';
          break;
      }

      const retrieve = () => {
        window.swinger
          .ajax(`${window.swinger.config.apiBase}${apiUrl}?itemsPerPage=12&dataset=${dataSet}`)
          .then((result) => {
            const items = recursiveLanguageResolve(
              processsearchresults(result[keyName]),
              language,
            );
            const totalItemCount = result.pagination.totalItemCount
              || result[keyName].length;
            if (!items.length) {
              return;
            }
            app.store.dispatch({
              type: 'UPDATE',
              value: {
                items: items.map((item) => ({
                  component: componentName,
                  data: item,
                })),
                totalItemCount,
              },
            });
          })
          .catch((e) => {
            if (e) {
              console.error(e);
            }
          });
      };
      let lastAuthStatus = window.swinger.user.isLoggedIn();
      let initialized = false;
      const init = () => {
        const isLoggedIn = window.swinger.user.isLoggedIn();
        if (isLoggedIn === lastAuthStatus && initialized) {
          return;
        }
        lastAuthStatus = window.swinger.user.isLoggedIn();
        if (!isLoggedIn) {
          return;
        }
        retrieve();
        initialized = true;
      };
      document.addEventListener('swinger.user:authchange', () => {
        init();
      });
      init();
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/library-slider/library-slider.js